var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLargeArrowTopLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7448 19.3275C23.7357 19.3315 23.7116 19.344 23.6778 19.3778L23.6743 19.3813L23.6743 19.3813L12.4743 30.4813L10.9257 28.9187L22.1222 17.8222C22.1228 17.8215 22.1234 17.8209 22.1241 17.8203C22.5602 17.3851 23.1321 17.125 23.75 17.125C24.3688 17.125 24.9415 17.3859 25.3778 17.8222L36.4778 28.9222L34.9222 30.4778L23.8222 19.3778C23.7883 19.344 23.7643 19.3315 23.7551 19.3275C23.7529 19.3266 23.7512 19.3259 23.75 19.3255C23.7487 19.3259 23.747 19.3266 23.7448 19.3275Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLargeArrowTopLight);
export default __webpack_public_path__ + "static/media/icon_large_arrow_top_light.2a76122b.svg";
export { ForwardRef as ReactComponent };